'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var CancelService = exports.CancelService = function () {
    function CancelService($q) {
        _classCallCheck(this, CancelService);

        this.$q = $q;

        // List of pending promises that may be cancelled
        this.promises = [];
    }

    // Register a promise as pending


    _createClass(CancelService, [{
        key: 'register',
        value: function register(promise) {
            if (!_.isFunction(promise.cancel)) {
                console.error('[CancelService] Registering an uncancelable promise:', promise);
            }
            this.promises.push(promise);
        }

        // Unregister a promise (because it has completed or been cancelled)

    }, {
        key: 'unregister',
        value: function unregister(promise) {
            var lengthBefore = this.promises.length;

            _.pull(this.promises, promise);

            // Sanity check
            if (this.promises.length !== lengthBefore - 1) {
                console.error('[CancelService] Tried to unregister a promise that isn\'t registered:', promise);
            }
        }

        // Return a cancelable promise that resolves immediately.
        // This is a wrapper on $q.resolve.

    }, {
        key: 'resolve',
        value: function resolve(value) {
            var _this = this;

            var promise = this.$q.resolve(value);
            promise.cancel = value && value.$$state && value.cancel ? function () {
                return value.cancel();
            } : function () {};
            this.register(promise);
            promise.catch(function () {}).then(function () {
                return _this.unregister(promise);
            });
            return promise;
        }

        // This is a wrapper on $q.all.

    }, {
        key: 'all',
        value: function all(value) {
            var _this2 = this;

            var promise = this.$q.all(value);
            promise.cancel = function () {
                _.forEach(value, function (sub) {
                    return _this2.cancel(sub);
                });
            };
            this.register(promise);
            promise.catch(function () {}).then(function () {
                return _this2.unregister(promise);
            });
            return promise;
        }

        // Cancel a pending promise.
        //
        // NOTE: The _promise_ parameter can be either the original promise, or
        // *any promise derived from it with then/catch/etc*.
        //
        // See https://itnext.io/how-to-cancel-http-requests-in-angularjs-4ccf351319e0
        // for an explanation of how this works.
        //

    }, {
        key: 'cancel',
        value: function cancel(promise) {
            // Find the root promise, i.e. the promise that was registered as pending,
            // so we can cancel it.
            var root = this.findRootPromise(promise);
            if (!root) {
                // Root promise not found.

                if (promiseIsFulfilled(promise)) {
                    // It's because the promise was already fulfilled and has been unregistered.
                    // This isn't really an error.
                    // console.warn('[CancelService] Tried to cancel an already-fulfilled promise.');
                } else {
                    console.error('[CancelService] Tried to cancel a promise not derived from a registered promise:', promise);
                }

                return;
            }

            if (_.isFunction(root.cancel)) {
                // console.log('[CancelService] Canceling pending promise:', root);
                root.cancel();
            } else {
                console.error('[CancelService] Tried to cancel an uncancelable promise:', root);
            }
        }

        // Find the root promise that _promise_ is derived from. Return null if
        // not found.

    }, {
        key: 'findRootPromise',
        value: function findRootPromise(promise) {
            return _.find(this.promises, function (root) {
                return promiseIsDescendantOf(promise, root);
            });
        }
    }]);

    return CancelService;
}();

CancelService.$inject = ['$q'];

function promiseIsFulfilled(promise) {
    return promise && promise.$$state && promise.$$state.status === 1;
}

function promiseIsDescendantOf(promise, root) {
    if (promise === root) {
        return true;
    }

    var children = root.$$state && root.$$state.pending || [];
    return _.some(children, function (child) {
        return promiseIsDescendantOf(promise, child[0]);
    });
}


//////////////////
// WEBPACK FOOTER
// ./src/winresCloud/cancelService.js
// module id = 573
// module chunks = 2